import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-css-day2',
  templateUrl: './css-day2.component.html',
  styleUrls: ['./css-day2.component.css']
})
export class CssDay2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
